import Router from "next/router";
import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

export const CancelListBackButton = () => {
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={() => {
        Router.push("/manage-users");
      }}
      css={buttonMargin}
    >
      キャンセル
    </Button>
  );
};
const buttonMargin = css({
  marginLeft: "16px",
});
